<div class="table-container no-actions fill">
    <table
        class="table"
        *ngIf="
            entrySummaries != null &&
            rpaIds != null &&
            authorityIds != null &&
            rpaIds.length > 0 &&
            statusSource === 'AUTO'
        "
    >
        <thead [ngClass]="{ 'row-even': rowEven }">
            <tr>
                <th style="width: 35%">RPA Type</th>
                <th style="width: 35%">RPA in type</th>
                <th style="width: 20%">Status</th>
                <th></th>
            </tr>
            <tr
                *ngIf="
                    authorityIndicatorLookup != null &&
                    ((primaryAuthorityPilotRegisterDisabled &&
                        authorityIds.length > 0) ||
                        authorityIds.length >= 2)
                "
            >
                <th></th>
                <th></th>
                <th *ngFor="let authId of authorityIds">
                    {{ authorityIndicatorLookup[authId] }}
                </th>
            </tr>
        </thead>
        <tbody [ngClass]="{ 'row-even': rowEven }">
            <tr *ngFor="let rpa of rpaIds">
                <td style="white-space: normal">
                    {{ rpaTypes[rpa] }}
                </td>
                <td style="white-space: normal">
                    {{ rpas[rpa] }}
                </td>
                <td *ngFor="let authId of authorityIds">
                    <span
                        *ngIf="
                            registerStatuses[rpa] != null &&
                            registerStatuses[rpa][authId] != null
                        "
                        class="status-block"
                        [ngClass]="
                            registerStatuses[rpa][authId].registerStatus
                                | registerStatusClass
                        "
                    >
                        {{
                            registerStatuses[rpa][authId].registerStatus
                                | formatMissionEditRegisterStatus
                        }}
                    </span>
                    <span
                        *ngIf="
                            registerStatuses[rpa] == null ||
                            registerStatuses[rpa][authId] == null
                        "
                    >
                        N/A
                    </span>
                </td>
            </tr>
        </tbody>
    </table>
    <span
        *ngIf="
            entrySummaries != null &&
            statusSource !== 'AUTO' &&
            statusSource !== 'NONE'
        "
        style="max-width: 100%; white-space: normal"
    >
        <ng-container
            *ngIf="
                statusSource === 'ACTIVE' ||
                statusSource === 'PENDING' ||
                statusSource === 'SUSPENDED'
            "
        >
            This person's status on the register has manually been set to
            {{ statusSource | formatMissionEditRegisterStatus }}. Register
            status details are not applicable in this case.
        </ng-container>
        <ng-container
            *ngIf="
                statusSource !== 'ACTIVE' &&
                statusSource !== 'PENDING' &&
                statusSource !== 'SUSPENDED'
            "
        >
            This person is:&nbsp;{{
                statusSource | formatMissionEditRegisterStatus
            }}
        </ng-container>
    </span>
    <span
        *ngIf="
            (entrySummaries != null && statusSource === 'NONE') ||
            entrySummaries == null
        "
    >
        No register status details available for this person.
    </span>
</div>
